<template>

	<div class="InputSigarusCheckboxList">
		<el-checkbox-group v-model="model">
			<el-checkbox
			v-for="(item, i) in list"
			:label="item.value"
			:key="i">{{item.label}}</el-checkbox>
		</el-checkbox-group>
	</div>

</template>

<script>
	export default {
		name: 'InputSigarusCheckboxList',
		props: {
			value: {
				default: ''
			},
			options: {
				type: Array,
				default: () => []
			}
		},
		data () {
			return {
				list: [],
				
			}
		},
		computed: {

			model: {

				get () { return this.value.split(',').map(a => +a) },

				set (val) {
					
					this.$emit('input', val.join())
					this.$emit('save', val.join())
				}
			}
		},
		created () {
			this.list = this.options
		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			onFocus() {
				
				this.$emit('focus')

				if (!this.remote) return
				
				this.remoteMethod()

			},

			$render() {
				return this.list.filter(f => this.model.includes(f.value)).map(m => m.label).join(', ')
			}
		}
	}
</script>

<style lang="scss">
.InputSigarusCheckboxList {
	height: 32px;
    display: flex;
    align-items: center;
    padding: 0 0.5rem;
}
</style>
